import type { PipeTransform } from '@angular/core';
import { Pipe, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import type { CountryCode } from 'libphonenumber-js';
import { AsYouType } from 'libphonenumber-js';
import type { OnyxOptional, OnyxPhone } from '../interfaces';

@Pipe({
  name: 'onyxPhone',
})
export class OnyxPhonePipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  public transform(phone: OnyxOptional<OnyxPhone>): string {
    if (!phone) return '-';

    const language =
      this.translateService.getCurrentLang() ??
      this.translateService.getFallbackLang();
    const formattedNumber = new AsYouType(language as CountryCode).input(
      `${phone.areaCode} ${phone.number}`,
    );

    return formattedNumber;
  }
}
